import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { color as ThemeColor } from "../../../../theme";
import { Wrapper } from "./styles";

export const Button = ({ label = "Default Button", suffix = null, prefix = null, color = ThemeColor.white, type = "primary", ...props }) => {
  return (
    <Wrapper className="cg-button" type={type} color={color} {...props}>
      {prefix && (
        <FontAwesomeIcon
          icon={prefix}
          color={color}
          className={"cls_mghunt63_fdae3e"}
        />
      )}
      {label}
      {suffix && (
        <FontAwesomeIcon
          icon={suffix}
          color={color}
          className={"cls_mghunt6c_b62cc3"}
        />
      )}
    </Wrapper>
  );
};
